// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oe-1";
export var messageSideRight = "_oe-2";
export var orderLookupBubbleContainer = "_oe-0";
export var submitButton = "_oe-3";